/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.preload)();
	(0, _module.tabletToggle)();
	(0, _module.accordionToggle)();
	(0, _module.tableScroll)();
	(0, _module.initScrollbar)();
	(0, _module.toggleMenu)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tableScroll = exports.toggleMenu = exports.accordionToggle = exports.initScrollbar = exports.loadAnime = exports.tabletToggle = exports.preload = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ------------------------------------------------------------------------
	// const anchorLink = () => {
	//   $("a[href^='#']").on("click", function(){
	//     let linkSpeed    = 800;
	//     let linkHref     = $(this).attr("href");
	//     let linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	//     let linkAdjust   = 0;
	//     let linkPosition = linkTarget.offset().top;
	//     return false;
	//   });
	// };
	// ------------------------------------------------------------------------
	// preload
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// tabletToggle
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var tabletToggle = function tabletToggle() {
	  $(window).on("load", function () {
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) {
	      $(".pc_f.entry-cta_button").addClass("tablet");
	      $(".sp_f.entry-cta_button").addClass("tablet");
	      $(".text-small.text-center.text-med.sp_b").removeClass("sp_b");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// loadAnime
	// ------------------------------------------------------------------------
	
	
	exports.tabletToggle = tabletToggle;
	
	var loadAnime = function loadAnime() {
	  $(window).on('load', function () {
	    $('.ld-anim').each(function () {
	      var target = $(this);
	      $(this).addClass("animated");
	    });
	  });
	}; // ------------------------------------------------------------------------
	// accordionToggle
	// ------------------------------------------------------------------------
	
	
	exports.loadAnime = loadAnime;
	
	var accordionToggle = function accordionToggle() {
	  $(".accordion-toggle").on("click", function () {
	    $(this).toggleClass("open");
	    $(this).next().toggleClass("open");
	    $(this).next().slideToggle(300);
	  });
	}; // ------------------------------------------------------------------------
	// initScrollbar
	// SP/タブレット時（デフォルトでオーバーレイスクロールがある場合）は無効
	// ------------------------------------------------------------------------
	
	
	exports.accordionToggle = accordionToggle;
	
	function togglescrllUI(scrollpos) {
	  if ($(".idx-Mv").length == true) {
	    var mvHeight = $(".idx-Mv_Inner").outerHeight();
	
	    if (scrollpos > mvHeight) {
	      $(".header-hamburger").addClass("scrolled");
	    } else {
	      $(".header-hamburger").removeClass("scrolled");
	    }
	  }
	
	  if (scrollpos > 500) {
	    $(".st-Pagetop").addClass("scrolled");
	  } else {
	    $(".st-Pagetop").removeClass("scrolled");
	  }
	}
	
	function togglescrllAnim(scrollpos) {
	  $('.sc-anim').each(function () {
	    var targetElm = $(this);
	    var targetPos = targetElm.position().top;
	    var windowHeight = $(window).height();
	    var per = 1.4;
	
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) {
	      targetElm.addClass("animated");
	    }
	
	    if (matchMedia('(max-width: 768px)').matches) {
	      per = 1.2;
	    }
	
	    if (scrollpos > targetPos - windowHeight + windowHeight * per) {
	      targetElm.addClass("animated");
	    }
	  });
	}
	
	var initScrollbar = function initScrollbar() {
	  var instance = $("body").overlayScrollbars({
	    scrollbars: {
	      autoHide: "move"
	    },
	    nativeScrollbarsOverlaid: {
	      initialize: false
	    },
	    callbacks: {
	      onScroll: function onScroll(e) {
	        var scrollPos = e.target.scrollTop;
	        togglescrllAnim(scrollPos);
	        togglescrllUI(scrollPos);
	      }
	    }
	  }).overlayScrollbars(); // その他スクロール系処理
	
	  var scrllValid = OverlayScrollbars.valid(instance);
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	
	    if (scrllValid) {
	      var linkAdjust = 0;
	      var linkPosition = linkTarget.position().top;
	      instance.scroll({
	        y: linkPosition - linkAdjust
	      }, 800, {
	        y: "swing"
	      });
	    } else {
	      var _linkAdjust = 40 * (windowWidth / 768);
	
	      var _linkPosition = linkTarget.offset().top;
	      $("html, body").animate({
	        scrollTop: _linkPosition - _linkAdjust
	      }, linkSpeed, "swing");
	    }
	
	    return false;
	  });
	  $(window).on("load scroll", function () {
	    var scrollPos = $(window).scrollTop();
	    togglescrllAnim(scrollPos);
	    togglescrllUI(scrollPos);
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ------------------------------------------------------------------------
	
	
	exports.initScrollbar = initScrollbar;
	
	var toggleMenu = function toggleMenu() {
	  $('.header-hamburger').on('click', function () {
	    $(this).toggleClass("open");
	    $(".header-nav").toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// resizeHeader
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var resizeHeader = function resizeHeader() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > 200) {
	      $(".header-hamburger").addClass("scrolled");
	    } else {
	      $(".header-hamburger").removeClass("scrolled");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// tableScroll
	// ------------------------------------------------------------------------
	
	
	var tableScroll = function tableScroll() {
	  $(window).on("load resize", function () {
	    if ($(".outline-schedule_wrap").length == true) {
	      var instance = $(".outline-schedule_wrap, .outline-schedule_wrap_team").overlayScrollbars({
	        scrollbars: {}
	      }).overlayScrollbars();
	    }
	  });
	};
	
	exports.tableScroll = tableScroll;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// entry/app.bundle.js